import { render, staticRenderFns } from "./StudioMedicoAmbulatoriListComponent.vue?vue&type=template&id=5918894a"
import script from "./StudioMedicoAmbulatoriListComponent.vue?vue&type=script&lang=js"
export * from "./StudioMedicoAmbulatoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports